import { render, staticRenderFns } from "./SlideshowPreview.vue?vue&type=template&id=afbf5596&scoped=true&"
import script from "./SlideshowPreview.vue?vue&type=script&lang=js&"
export * from "./SlideshowPreview.vue?vue&type=script&lang=js&"
import style0 from "./SlideshowPreview.vue?vue&type=style&index=0&id=afbf5596&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbf5596",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
